var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwesomeStarIconEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.47,
    height: 16.721,
    viewBox: "0 0 17.47 16.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-empty",
    "data-name": "Icon awesome-star-empty",
    d: "M9.239.581,7.107,4.9l-4.771.7a1.045,1.045,0,0,0-.578,1.783L5.21,10.746,4.393,15.5a1.044,1.044,0,0,0,1.515,1.1l4.268-2.243L14.444,16.6a1.045,1.045,0,0,0,1.515-1.1l-.816-4.751,3.451-3.363A1.045,1.045,0,0,0,18.016,5.6l-4.771-.7L11.113.581A1.046,1.046,0,0,0,9.239.581Z",
    transform: "translate(-1.441 0.001)",
    fill: "none",
    stroke: "#040227",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeStarIconEmpty);
export default __webpack_public_path__ + "static/media/awesome-star-icon-empty.cb5f224e2fccb2d12a36b9f03727bb4e.svg";
export { ForwardRef as ReactComponent };